type PodV2Search = {
    publishGrpId?: number;
    publishId?: number;
};

export type PodV2CachedPublishSet = {
    setsId: string;
    title: string;
};

const getPodV2PublishGroupCacheKey = (publishGrpId: number) =>
    `pod-v2:publish-group:${publishGrpId}`;

const isPodV2CachedPublishSet = (value: unknown): value is PodV2CachedPublishSet =>
    typeof value === 'object' &&
    value !== null &&
    typeof Reflect.get(value, 'setsId') === 'string' &&
    typeof Reflect.get(value, 'title') === 'string';

export const getPodV2PublishGroupCache = (publishGrpId: number): PodV2CachedPublishSet[] => {
    try {
        const cached = window.sessionStorage.getItem(getPodV2PublishGroupCacheKey(publishGrpId));
        if (!cached) return [];

        const parsed: unknown = JSON.parse(cached);
        return Array.isArray(parsed) ? parsed.filter(isPodV2CachedPublishSet) : [];
    } catch {
        return [];
    }
};

export const setPodV2PublishGroupCache = (
    publishGrpId: number,
    publishSets: PodV2CachedPublishSet[]
) => {
    window.sessionStorage.setItem(
        getPodV2PublishGroupCacheKey(publishGrpId),
        JSON.stringify(publishSets)
    );
};

export const moveToPodV2 = ({ publishGrpId, publishId }: PodV2Search) => {
    const podUrl = new URL('/sets/pod-v2', window.location.origin);
    const returnTo = `${window.location.pathname}${window.location.search}${window.location.hash}`;

    if (publishGrpId) podUrl.searchParams.set('publishGrpId', String(publishGrpId));
    if (publishId) podUrl.searchParams.set('publishId', String(publishId));
    podUrl.searchParams.set('returnTo', returnTo);

    // POD and AIDT define overlapping viewer elements, so POD needs a fresh document.
    window.location.assign(podUrl);
};

export const getPodV2ExitUrl = (returnTo?: string) => {
    if (!returnTo) return '/my-bank';

    try {
        const returnUrl = new URL(returnTo, window.location.origin);
        const normalizedPathname = returnUrl.pathname.replace(/\/+$/, '');
        if (returnUrl.origin !== window.location.origin || normalizedPathname === '/sets/pod-v2') {
            return '/my-bank';
        }

        return `${returnUrl.pathname}${returnUrl.search}${returnUrl.hash}`;
    } catch {
        return '/my-bank';
    }
};
